<template>
  <div
    class="page-header header-filter Footer_Auto_Height jipvio-signup"
    style="background-color: #ffffff"
    v-loading="loading"
  >
    <div class="page-header-image"></div>
    <div class="content">
      <div class="container container_max_width container_padding_reset">
        <div v-if="showIntro">
          <card plain>
            <div slot="header" class="logo-container jipvio-login-color">
              <h2>집비오 회원가입</h2>
            </div>
            <div class="Sign_Up_intro">
              <p>
                지금 바로 신규회원 가입하고,
                <span class="word_space"
                  >집비오에 등록한 다양한 집들을 만나보세요!</span
                >
                <!-- <span>#지금 바로 가입하면,중개수수료 30% 할인쿠폰 제공</span> -->
              </p>
              <ul class="Sign_menu">
                <li>
                  <a href="#" @click="signupForm('JVO')">
                    <i class="far fa-envelope"></i>
                    <span><strong>이메일</strong>로 가입하기</span></a
                  >
                </li>
                <li>
                  <a href="#" @click="signupForm('KKO')">
                    <i class="jipvio-ui-icons-kakao"></i>
                    <span><strong>카카오</strong>로 가입하기</span></a
                  >
                </li>
                <li>
                  <a href="#" @click="signupForm('NVO')">
                    <i class="jipvio-ui-icons-naver"></i>
                    <span><strong>네이버</strong>로 가입하기</span></a
                  >
                </li>
              </ul>
              <ul class="Sign_bottom">
                <li>
                  <p><i class="far fa-check-circle"></i> 이미 가입하셨나요?</p>
                </li>
                <li><a href="/login">로그인하기</a></li>
              </ul>
            </div>
          </card>
        </div>

        <!-- sign up -->
        <div class="ml-auto mr-auto" v-if="!showIntro">
          <div plain class="card-body card_padding_reset">
            <div slot="header" class="logo-container jipvio-login-color">
              <h2>집비오 회원가입</h2>
            </div>
            <div class="Sign_Up">
              <div class="Sign_Up_header">
                <p>
                  아래 정보만 간단하게 입력하세요!<br />
                  회원가입이 완료됩니다.
                </p>
              </div>
              <div class="Sign_Up_menu row ml-0 mr-0">
                <ul class="m-auto pl-0">
                  <li class="col-4">
                    <a
                      href="#"
                      @click="
                        signupUserInfo.type = 'AG';
                        resetData();
                      "
                      ><span>공인중개사이신가요?</span><br /><strong
                        >'공인중개사'로<br />가입</strong
                      ></a
                    >
                  </li>
                  <li class="col-4">
                    <a
                      href="#"
                      @click="
                        signupUserInfo.type = 'LO';
                        resetData();
                      "
                      ><span>임대인이신가요?</span><br /><strong
                        >'임대인'으로<br />가입</strong
                      ></a
                    >
                  </li>
                  <li class="col-4">
                    <a
                      href="#"
                      @click="
                        signupUserInfo.type = 'LE';
                        resetData();
                      "
                      ><span>집을 찾고 계신가요?</span><br /><strong
                        >'일반'으로<br />가입</strong
                      ></a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="Sign_Up_content" v-show="signupUserInfo.type != null">
              <!-- 공인중개사 가입-->
              <!-- 왼쪽 -->
              <ValidationObserver ref="REAForm">
                <div class="Sign_Up_Page" v-if="signupUserInfo.type == 'AG'">
                  <div class="L_box">
                    <div class="L_box_header">
                      <h2><span>‘공인중개사’</span>로 가입하기</h2>
                      <p>
                        공인중개사 회원은 회원가입 시,<br />중개업소 등록 조회가
                        필수입니다.
                      </p>
                      <!-- <p>
                        공인중개사 회원은 회원가입 시,<br />중개업소 등록 조회,
                        대표자 본인인증 등이 필수입니다.
                      </p> -->
                    </div>
                    <!-- 중개업소 조회 -->
                    <div class="Broker_Lookup">
                      <label
                        >중개사무소 상호명
                        <ValidationProvider
                          ref="offNmVal"
                          rules="required"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.officeName"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                            :disabled="checkAgcyYn"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <label
                        >중개사무소 등록번호
                        <ValidationProvider
                          ref="offRegNumVal"
                          rules="required"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.officeRegNum"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                            :disabled="checkAgcyYn"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <label
                        >대표자명
                        <ValidationProvider
                          ref="ceoNmVal"
                          rules="required"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.ceoName"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                            :disabled="checkAgcyYn"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <div class="R_btn">
                        <span class="Sign_Up_errMsgAG">{{ agcyCheckMsg }}</span>
                        <el-button
                          round
                          @click="checkAgencyInfo()"
                          :disabled="checkAgcyYn"
                          >중개업소 조회</el-button
                        >
                      </div>
                    </div>
                    <!-- 중개사무소 등록증 -->
                    <div class="upload">
                      <h3>중개사무소 등록증</h3>
                      <br />
                      <el-upload
                        :limit="1"
                        :auto-upload="false"
                        action="#"
                        :on-change="uploadChange"
                        :on-remove="removeFile"
                        :on-exceed="exceedFileLimit"
                        :file-list="uploadFile.fileList"
                      >
                        <el-button round>업로드</el-button>
                      </el-upload>
                    </div>
                    <!-- 휴대전화 인증 서비스 인증 후 추가 -->
                    <!-- <div class="phone">
                      <h3>휴대전화 인증</h3>
                      <br />
                      <el-button round>휴대폰 본인인증</el-button>
                    </div> -->

                    <!-- 비밀번호 -->
                    <div class="Pw_box">
                      <div class="Pw">
                        <label v-if="jpvLogin"
                          >비밀번호 입력
                          <ValidationProvider
                            name="REAPw"
                            rules="required|pwMin"
                            v-slot="{ failed }"
                          >
                            <fg-input
                              type="password"
                              v-model="signupUserInfo.password"
                              :error="failed ? ' ' : null"
                              @change="checkAll()"
                            ></fg-input>
                          </ValidationProvider>
                        </label>

                        <label v-if="jpvLogin"
                          >비밀번호 확인
                          <ValidationProvider
                            rules="required|pwCheck:@REAPw"
                            v-slot="{ failed }"
                          >
                            <fg-input
                              type="password"
                              v-model="pwForCheck"
                              :error="failed ? ' ' : null"
                              @change="checkAll()"
                            ></fg-input>
                          </ValidationProvider>
                        </label>

                        <label v-if="jpvLogin"
                          >이메일 입력(로그인 아이디로 사용)

                          <ValidationProvider
                            rules="required|email"
                            v-slot="{ failed }"
                          >
                            <fg-input
                              v-model="signupUserInfo.email"
                              :error="failed ? ' ' : null"
                              @change="checkAll()"
                            ></fg-input>
                          </ValidationProvider>
                        </label>
                      </div>

                      <div class="Join_bottom row ml-0 mr-0" v-if="jpvLogin">
                        <span class="Sign_Up_errMsgCB col-12 px-0">{{
                          errMsg
                        }}</span>
                        <el-checkbox
                          v-model="jpvAgreeYn"
                          class="Cbox col-12 px-0"
                          @change="ModalView()"
                          ><strong>전체약관 동의</strong> 집비오 서비스
                          이용약관<b>(필수)</b></el-checkbox
                        >

                        <el-button
                          round
                          class="Sign_Up_btn col-7 m-auto px-0"
                          @click="validate()"
                          >가입완료</el-button
                        >
                      </div>
                    </div>
                    <div class="Join row ml-0 mr-0" v-if="!jpvLogin">
                      <span class="Sign_Up_errMsg col-12">{{ errMsg }}</span>
                      <el-checkbox
                        v-model="jpvAgreeYn"
                        class="Cbox col-12"
                        @change="ModalView()"
                        ><strong>전체약관 동의</strong> 집비오 서비스 이용약관<b
                          >(필수)</b
                        ></el-checkbox
                      >
                      <el-button
                        round
                        class="Sign_Up_btn col-7 m-auto"
                        @click="validate()"
                        >가입완료</el-button
                      >
                    </div>
                    .
                    <!-- 오른쪽 -->
                  </div>
                  <div class="R_box">
                    <div class="R_box_header">
                      <h2>
                        <strong>'공인중개사'</strong>로 가입하시면,<br />아래
                        서비스를 이용하실 수 있습니다.
                      </h2>
                    </div>
                    <div class="R_box_content">
                      <div class="text_box">
                        <i class="now-ui-icons media-2_sound-wave"></i>
                        <h3>전문적인 부동산 정보 이용</h3>
                        <p>
                          건축물대장, 실거래가 데이터 등을 기반으로 한 전문적인
                          부동산 정보를 제공합니다.
                        </p>
                      </div>

                      <div class="text_box">
                        <i class="fas fa-history"></i>
                        <h3>업무 효율성 증가(시간 절감)</h3>
                        <p>
                          건축물대장을 보며 일일이 입력했던 부동산 정보들이,
                          소재지(주소) 입력 하나로 자동으로 입력됩니다.
                        </p>
                      </div>
                      <div class="text_box">
                        <i class="far fa-images"></i>
                        <h3>다양한 이미지 등록 가능</h3>
                        <p>
                          비대면에 용이한 360도 VR이미지, 열화상이미지 등의
                          전문적인 이미지를 등록하실 수 있습니다.
                        </p>
                      </div>
                      <div class="text_box">
                        <i class="el-icon-coin"></i>
                        <h3>이용료 무료</h3>
                        <p>
                          공인중개사 회원은 무료로 전속중개계약을 맺은 매물을
                          등록할 수 있습니다.
                        </p>
                        <p>
                          집비오는 공동중개 플랫폼으로, 집비오를 통해 임차인의
                          의뢰가 있을시, 공동중개로 계약이 진행됩니다.
                        </p>
                        <p>
                          (직접 계약한 건에 경우에는 공동중개로 볼 수 없으므로,
                          집비오는 수수료를 청구하지 않습니다.)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ValidationObserver>

              <!-- 임대인 가입 -->
              <!-- 왼쪽 -->
              <ValidationObserver ref="LeaserForm">
                <div class="Sign_Up_Page" v-if="signupUserInfo.type == 'LO'">
                  <div class="L_box">
                    <div class="L_box_header">
                      <h2><span>‘임대인’</span>으로 가입하기</h2>
                      <p>
                        임대인 회원은 회원가입 시,<br />
                        방내놓기 서비스를 이용하실 수 있습니다.
                      </p>
                      <!-- <p>
                        임대인 회원은 회원가입 시,<br />
                        소유주 확인을 위해 본인인증이 필수입니다.
                      </p> -->
                    </div>
                    <!-- 중개업소 조회 -->
                    <div class="Broker_Lookup">
                      <label v-if="jpvLogin"
                        >아이디 입력(이메일 형식)
                        <ValidationProvider
                          rules="required|email"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.email"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <label
                        >성명
                        <ValidationProvider
                          rules="required"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.name"
                            :error="failed ? ' ' : null"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                    </div>
                    <!-- 휴대전화 인증  서비스 연동 후 추가 -->
                    <!-- <div class="phone">
                      <h3>휴대전화 인증</h3>
                      <br />
                      <el-button round>휴대폰 본인인증</el-button>
                    </div> -->

                    <!-- 비밀번호 -->
                    <div class="Pw">
                      <label v-if="jpvLogin"
                        >비밀번호 입력
                        <ValidationProvider
                          name="LeaserPw"
                          rules="required|pwMin"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            type="password"
                            v-model="signupUserInfo.password"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <label v-if="jpvLogin"
                        >비밀번호 확인
                        <ValidationProvider
                          rules="required|pwCheck:@LeaserPw"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            type="password"
                            v-model="pwForCheck"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <label
                        >이메일 입력(안내 수신용 이메일)
                        <ValidationProvider
                          rules="required|email"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.EmForNotice"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                    </div>

                    <div class="Join row ml-0 mr-0">
                      <span class="Sign_Up_errMsg col-12">{{ errMsg }}</span>
                      <el-checkbox
                        v-model="jpvAgreeYn"
                        class="Cbox col-12"
                        @change="ModalView()"
                        ><strong>전체약관 동의</strong> 집비오 서비스 이용약관<b
                          >(필수)</b
                        ></el-checkbox
                      >
                      <el-button
                        round
                        class="Sign_Up_btn col-7 m-auto"
                        @click="validate()"
                        >가입완료</el-button
                      >
                    </div>

                    <!-- 오른쪽 -->
                  </div>
                  <div class="R_box">
                    <div class="R_box_header">
                      <h2>
                        <strong>'임대인'</strong>으로 가입하시면,<br />아래
                        서비스를 이용하실 수 있습니다.
                      </h2>
                    </div>
                    <div class="R_box_content">
                      <div class="text_box">
                        <i class="now-ui-icons media-2_sound-wave"></i>
                        <h3>전문적인 부동산 정보 이용</h3>
                        <p>
                          건축물대장, 실거래가 데이터 등을 기반으로 한 전문적인
                          부동산 정보를 제공합니다.
                        </p>
                      </div>

                      <div class="text_box">
                        <i class="fas fa-history"></i>
                        <h3>시간 절약</h3>
                        <p>
                          건축물대장을 보며 일일이 입력했던 부동산 정보들이,
                          소재지(주소) 입력 하나로 자동으로 입력됩니다.
                        </p>
                      </div>
                      <div class="text_box">
                        <i class="far fa-images"></i>
                        <h3>다양한 이미지 제공</h3>
                        <p>
                          비대면에 용이한 360도 VR이미지, 열화상이미지 등의
                          전문적인 이미지를 등록하실 수 있습니다.
                        </p>
                      </div>
                      <div class="text_box">
                        <i class="el-icon-coin"></i>
                        <h3>중개수수료 할인</h3>
                        <p class="size_down">
                          집비오를 통해 계약을 체결하시면, 다양한 이벤트를 통해
                          발급되는 쿠폰을 사용하여 중개수수료를 절감하실 수
                          있습니다.
                        </p>
                        <p>
                          또한, 리뷰를 남겨주시면 중개수수료 결제 시 사용하실 수
                          있는 적립금을 제공합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ValidationObserver>

              <!-- 일반 가입 -->
              <!-- 왼쪽 -->
              <ValidationObserver ref="CustomerForm">
                <div class="Sign_Up_Page" v-if="signupUserInfo.type == 'LE'">
                  <div class="L_box">
                    <div class="L_box_header">
                      <h2><span>‘일반’</span>으로 가입하기</h2>
                      <p>
                        일반 회원은 회원가입 시, <br />
                        다양한 정보를 확인하실 수 있습니다.
                      </p>
                      <!-- <p>
                        일반 회원은 회원가입 시, <br />
                        본인인증이 필수입니다.
                      </p> -->
                    </div>
                    <!-- 중개업소 조회 -->
                    <div class="Broker_Lookup">
                      <label v-if="jpvLogin"
                        >아이디 입력(이메일 형식)
                        <ValidationProvider
                          rules="required|email"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.email"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <label
                        >성명
                        <ValidationProvider
                          rules="required"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.name"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                    </div>

                    <!-- 휴대전화 인증 서비스 연동 후 추가 -->
                    <!-- <div class="phone">
                      <h3>휴대전화 인증</h3>
                      <br />
                      <el-button round>휴대폰 본인인증</el-button>
                    </div> -->

                    <!-- 비밀번호 -->
                    <div class="Pw">
                      <label v-if="jpvLogin"
                        >비밀번호 입력
                        <ValidationProvider
                          name="customerPw"
                          rules="required|pwMin"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            type="password"
                            v-model="signupUserInfo.password"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <label v-if="jpvLogin"
                        >비밀번호 확인
                        <ValidationProvider
                          rules="required|pwCheck:@customerPw"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            type="password"
                            v-model="pwForCheck"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                      <label
                        >이메일 입력(안내 수신용 이메일)
                        <ValidationProvider
                          rules="required|email"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            v-model="signupUserInfo.EmForNotice"
                            :error="failed ? ' ' : null"
                            @change="checkAll()"
                          ></fg-input>
                        </ValidationProvider>
                      </label>
                    </div>

                    <div class="Join row ml-0 mr-0">
                      <span class="Sign_Up_errMsg col-12">{{ errMsg }}</span>
                      <el-checkbox
                        v-model="jpvAgreeYn"
                        class="Cbox col-12"
                        @change="ModalView()"
                        ><strong>전체약관 동의</strong> 집비오 서비스 이용약관<b
                          >(필수)</b
                        ></el-checkbox
                      >
                      <el-button
                        round
                        class="Sign_Up_btn col-7 m-auto"
                        @click="validate()"
                        >가입완료</el-button
                      >
                    </div>
                    <!-- 오른쪽 -->
                  </div>
                  <div class="R_box">
                    <div class="R_box_header">
                      <h2>
                        <strong>'일반'</strong>으로 가입하시면,<br />아래
                        서비스를 이용하실 수 있습니다.
                      </h2>
                    </div>
                    <div class="R_box_content">
                      <div class="text_box">
                        <i class="now-ui-icons media-2_sound-wave"></i>
                        <h3>전문적인 부동산 정보 이용</h3>
                        <p>
                          건축물대장, 실거래가 데이터 등을 기반으로 한 전문적인
                          부동산 정보를 제공합니다.
                        </p>
                      </div>

                      <div class="text_box">
                        <i class="fas fa-history"></i>
                        <h3>시간 절감</h3>
                        <p>
                          ‘집비오’는 하나의 매물만 올라가기 때문에, 중복 매물,
                          허위 매물 때문에 낭비되는 시간을 절약할 수 있습니다.
                        </p>
                      </div>
                      <div class="text_box">
                        <i class="far fa-images"></i>
                        <h3>비대면 환경 제공</h3>
                        <p>
                          비대면에 용이한 360도 VR이미지, 열화상이미지 등의
                          전문적인 이미지를 등록하실 수 있습니다.
                        </p>
                      </div>
                      <div class="text_box">
                        <i class="el-icon-coin"></i>
                        <h3>중개수수료 할인</h3>
                        <p class="size_down">
                          집비오를 통해 계약을 체결하시면, 다양한 이벤트를 통해
                          발급되는 쿠폰을 사용하여 중개수수료를 절감하실 수
                          있습니다.
                        </p>
                        <p>
                          또한, 리뷰를 남겨주시면 중개수수료 결제 시 사용하실 수
                          있는 적립금을 제공합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ValidationObserver>
              <!-- modal -->
              <card class="modal" v-show="checkModal">
                <div slot="header" class="modalHeader">
                  <h3 class="fl pl-20" style="line-height:55px;">
                    집비오 서비스 이용약관
                  </h3>
                  <span
                    class="el-icon-close fr pr-15"
                    style="fontSize:2.25em; line-height:58px; cursor: pointer;"
                    @click="TermsCheck(0)"
                  ></span>
                </div>
                <Terms />
                <div>
                  <el-button @click="TermsCheck(1)"
                    ><span class="el-icon-check"></span> 동의</el-button
                  >
                  <el-button @click="TermsCheck(0)"
                    ><span class="el-icon-close"></span> 비동의</el-button
                  >
                </div>
              </card>
            </div>
            <!-- Sign_Up_content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card } from "@/components";
import MainFooter from "@/layout/MainFooter";
import Terms from "@/pages/jipvio/GeneralViews/Terms.vue";
import {
  Button,
  ColorPicker,
  input,
  Checkbox,
  Message,
  Loading,
  Upload
} from "element-ui";
import userApi from "@/service/user";
import openApi from "@/service/openapi";
import filestoreApi from "@/service/filestore";

import { required, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("email", email);
extend("required", required);
extend("true", value => {
  return value == true;
});

extend("pwMin", value => {
  return value.length >= 6;
});
extend("pwCheck", {
  validate(value, { target }) {
    return value === target;
  },
  params: ["target"]
});

import { createNamespacedHelpers } from "vuex";
const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    Card,
    Terms,
    MainFooter,
    [Button.name]: Button,
    [input.name]: input,
    [Checkbox.name]: Checkbox,
    [Message.name]: Message,
    [Loading.name]: Loading,
    [Upload.name]: Upload
  },

  data() {
    return {
      showIntro: true,
      jpvLogin: true,

      signupUserInfo: {
        //공통
        type: null,
        authProviderId: null,
        uid: null,
        email: null,
        password: null,
        name: null,
        EmForNotice: null, //수신용 이메일

        //공인중개사
        officeName: null, //중개사무소 상호명
        officeRegNum: null, //중개사무소 등록번호
        ceoName: null, // 대표자명,
        upldId: null, // 중개사 등록증 파일 id,
        termAgreeYn: null // 개인정보 동의 여부
      },

      checkAgcyYn: false,
      agcyCheckMsg: null,

      pwForCheck: null,
      jpvAgreeYn: null,
      errMsg: null,

      loading: false,

      checkHeaderFooter: false,
      checkModal: false,

      uploadFile: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: []
      }
    };
  },

  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap"
    })
  },
  mounted() {
    const script = document.createElement("script");
    script.onload = () => {};
    script.src = "https://developers.kakao.com/sdk/js/kakao.js";
    document.head.appendChild(script);
  },
  created() {
    if (this.$route.query.state !== undefined) {
      this.showIntro = false;
      this.jpvLogin = false;
      this.sessionCoCodeMap.APV.forEach((ele, dex) => {
        if (ele.code === this.$route.query.state) {
          this.signupUserInfo.authProviderId = ele.id;
        }
      });
    }
    if (this.$route.query.code !== undefined) {
      this.signupUserInfo.code = this.$route.query.code;
      if (this.$route.query.state === "KKO") {
        this.getOauthUserInfo("KKO");
      }
    }
  },
  methods: {
    ModalView() {
      this.jpvAgreeYn = false;
      this.checkModal = !this.checkModal;
      this.checkJpvAgr();
    },
    TermsCheck(state) {
      if (state == true) {
        this.jpvAgreeYn = true;
        this.checkJpvAgr();
      } else {
        this.jpvAgreeYn = false;
        this.checkJpvAgr();
      }
      this.checkModal = false;
    },

    signupForm(state) {
      if (state === "JVO") {
        this.showIntro = false;
        this.sessionCoCodeMap.APV.forEach((ele, dex) => {
          if (ele.code === state) {
            this.signupUserInfo.authProviderId = ele.id;
          }
        });
      } else {
        Message.warning(
          "서비스 준비 중입니다. 빠른 시일 내에 서비스하겠습니다."
        );
      }
      // else if (state === "KKO") {
      //   // this.getKakaoSingupForm();
      // }
    },
    async getOauthUserInfo(state) {
      // 카카오, 네이버 정보 조회
      if (state === "KKO") {
        const res = await userApi.getOauthUserInfo(
          state,
          this.signupUserInfo.code
        );
        if (res.status === 200) {
          this.signupUserInfo.uid = res.payload.id;
          if (res.payload.kakao_account.email) {
            this.signupUserInfo.email = res.payload.kakao_account.email;
            this.signupUserInfo.EmForNotice = res.payload.kakao_account.email;
          }
        }
        console.log("============== Oauth 회원가입 정보");
        console.log(this.signupUserInfo);
      }
    },
    async signup() {
      console.log("==== 회원가입시도");
      console.log(this.signupUserInfo);
      // if (this.$route.query.state !== "JVO") {
      if (this.$route.query.state !== undefined) {
        const signUpRes = await userApi.saveUser(this.signupUserInfo);
        console.log(signUpRes);
        if (signUpRes.status === 200) {
          Message.success("회원가입이 완료되었습니다.");
          // if ((this.signupUserInfo.type = "AG")) {
          //   this.regUpload();
          // }
          this.$router.push("/login");
        } else {
          Message.error(signUpRes.message);
          this.$router.push("/signup");
        }
      } else {
        // 집비오 회원가입
        const signUpRes = await userApi.saveUser(this.signupUserInfo);
        console.log(signUpRes);
        if (signUpRes.status === 200) {
          Message.success("회원가입이 완료되었습니다.");
          // if ((this.signupUserInfo.type = "AG")) {
          //   this.regUpload();
          // }
          this.$router.push("/login");
        } else {
          Message.error(signUpRes.message);
          this.$router.push("/signup");
        }
      }
    },
    getKakaoSingupForm() {
      console.log("====Get Kakao Account");
      if (!Kakao.isInitialized()) {
        Kakao.init(process.env.VUE_APP_KKO_SDK_KEY);
      }
      // if (!Kakao.Auth.getAccessToken()) {
      //   console.log("Not logged in.");
      //   return;
      // }

      Kakao.Auth.authorize({
        redirectUri: `http://${window.location.host}/signup`,
        state: "KKO",
        scope: "account_email",
        throughTalk: false
      });
    },

    async checkAgencyInfo() {
      this.agcyCheckMsg = null;

      const res1 = await this.$refs["offNmVal"].validate();
      const res2 = await this.$refs["offRegNumVal"].validate();
      const res3 = await this.$refs["ceoNmVal"].validate();

      if (!res1.valid || !res2.valid || !res3.valid) {
        this.agcyCheckMsg = "정보를 입력해주세요";
        return;
      }

      if (this.agcyCheckMsg == null) {
        this.loading = true;
        const checkRes = await openApi.checkAgencyInfo(this.signupUserInfo);
        this.loading = false;

        console.log(checkRes);

        if (checkRes.payload == undefined) {
          this.agcyCheckMsg = "다시 검색해주세요";
          Message.error("다시 검색해주세요");
          return;
        }
        if (checkRes.payload == false) {
          this.agcyCheckMsg = "정보를 다시 한 번 확인해주세요";
          Message.error("정보를 다시 한 번 확인해주세요");
          return;
        }

        Message.success("확인 되었습니다");
        this.checkAgcyYn = checkRes.payload;
        this.agcyCheckMsg = null;
      }
    },

    resetData() {
      if (this.$route.query.state == undefined) {
        this.signupUserInfo.email = null;
        this.signupUserInfo.EmForNotice = null;
      }
      this.signupUserInfo.password = null;
      this.signupUserInfo.name = null;
      this.signupUserInfo.officeName = null;
      this.signupUserInfo.officeRegNum = null;
      this.signupUserInfo.ceoName = null;
      this.pwForCheck = null;
      this.jpvAgreeYn = null;
      this.agcyCheckMsg = null;
      this.errMsg = null;
      this.uploadFile = {
        data: null,
        fileList: [],
        idArr: [],
        removedIdArr: []
      };
    },

    checkAll() {
      if (this.signupUserInfo.type == "AG") {
        if (this.errMsg != null) {
          return this.$refs.REAForm.validate().then(res => {
            if (res) {
              this.errMsg = null;
              return;
            }
          });
        }
      }

      if (this.signupUserInfo.type == "LO") {
        return this.$refs.LeaserForm.validate().then(res => {
          if (res) {
            this.errMsg = null;
            return;
          }
        });
      }
      if (this.signupUserInfo.type == "LE") {
        return this.$refs.CustomerForm.validate().then(res => {
          if (res) {
            this.errMsg = null;
            return;
          }
        });
      }
    },

    checkJpvAgr() {
      if (this.jpvAgreeYn == true) {
        this.errMsg = null;
      } else {
        this.errMsg = "약관에 동의해주세요";
      }
    },

    validate() {
      if (this.signupUserInfo.type == "AG") {
        return this.$refs.REAForm.validate().then(res => {
          if (!res) {
            this.errMsg = "입력사항을 확인해주세요.";
            return;
          }

          if (this.checkAgcyYn == false) {
            this.errMsg = "중개업소 조회를 해주세요.";
            Message.error("중개업소 조회를 해주세요.");
            return;
          }

          if (this.uploadFile.fileList.length < 1) {
            this.errMsg = "중개사무소 등록증을 등록 해주세요.";
            Message.error("중개사무소 등록증을 등록 해주세요.");
            return;
          }

          if (this.jpvAgreeYn == false || this.jpvAgreeYn == null) {
            this.errMsg = "약관에 동의해주세요";
            Message.error("약관에 동의해주세요");
            return;
          }

          this.signup();
        });
      }

      if (this.signupUserInfo.type == "LO") {
        return this.$refs.LeaserForm.validate().then(res => {
          if (!res) {
            this.errMsg = "입력사항을 확인해주세요.";
            return;
          }
          if (this.jpvAgreeYn == false || this.jpvAgreeYn == null) {
            this.errMsg = "약관에 동의해주세요";
            Message.error("약관에 동의해주세요");
            return;
          }
          this.signup();
        });
      }
      if (this.signupUserInfo.type == "LE") {
        return this.$refs.CustomerForm.validate().then(res => {
          if (!res) {
            this.errMsg = "입력사항을 확인해주세요.";
            return;
          }
          if (this.jpvAgreeYn == false || this.jpvAgreeYn == null) {
            this.errMsg = "약관에 동의해주세요";
            Message.error("약관에 동의해주세요");
            return;
          }
          this.signup();
        });
      }
    },

    //======================================== 파일 업로드 메소드들

    // 파일첨부시(업로드x) 이벤트
    uploadChange: function(file, fileList) {
      console.log("fileList: ", fileList);
      this.uploadFile.fileList = fileList;
      this.uploadFile.fileList.forEach(file => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.uploadFile.fileList.splice(
            this.uploadFile.fileList.indexOf(file),
            1
          );
          return;
        }
      });
    },
    // 선택한 파일 삭제
    removeFile: function(file, fileList) {
      this.uploadFile.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.uploadFile.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },
    // 지정한 파일갯수를 초과해서 첨부했을 때
    exceedFileLimit: function() {
      Message.warning("파일첨부는 1개까지만 가능합니다.");
    },

    async regUpload() {
      console.log("파일업로드");

      if (
        this.uploadFile.fileList.length &&
        this.uploadFile.fileList
          .map(file => file.size)
          .reduce((acc, curr) => acc + curr) >
          100 * 1000 * 1000
      ) {
        Message.warning("파일 전체 크키는 100MB를 초과할 수 없습니다.");
        return;
      }

      if (this.uploadFile.fileList.length > 0) {
        let formData = new FormData();
        this.uploadFile.fileList.forEach(file =>
          formData.append("files", file.raw)
        ); // append raw file info

        const res = await filestoreApi.uploadMultipleFiles(formData); // 다중파일 업로드
        console.log(res);

        res.payload.forEach(fileItem =>
          this.uploadFile.idArr.push(fileItem.id)
        );
      }
      if (this.uploadFile.removedIdArr.length > 0) {
        for (let i = 0; i < this.uploadFile.removedIdArr.length; i++) {
          let removalId = this.uploadFile.removedIdArr[i];
          const deleteRes = await filestoreApi.deleteFile(removalId); // 파일삭제API 호출
          if (deleteRes.status === 200) {
            // 삭제성공 시, 삭제된 파일들의 id정보를 저장 -> Notice테이블의 파일참조Id에서 삭제
            this.uploadFile.idArr.splice(
              this.uploadFile.idArr.indexOf(removalId),
              1
            );
          }
        }
      }

      // 매물 관련 업로드 file id list 이용
      //this.uploadFile.idArr.toString()
    }
  }
};
</script>
<style>
/* modal */
.card.modal {
  color: #000;
  top: -50%;
  left: 50%;
  transform: translate(-49.2%, -50%);
}
.modal .features-3 {
  padding: 20px 0;
  font-size: calc(0.5em + 0.3vw);
}
.modal .modalHeader {
  background-color: #434343;
  height: 55px;
  color: white;
  font-size: calc(0.5em + 0.3vw);
}
.page-header .modal .container {
  color: inherit;
  margin-top: 0;
  background-color: #f6f6f6;
  overflow-y: scroll;
  height: 500px;
}
.page-header .modal .title {
  color: inherit;
}
.page-header .modal .description {
  color: #9a9a9a;
}
.header-filter .modal .info-title {
  color: inherit;
}
/* modal */

.Sign_Up_errMsgAG {
  color: red;
  margin-right: 5px;
}
.Sign_Up_errMsgCB {
  color: red;
  position: absolute;
  bottom: 24%;
  left: 50%;
  transform: translateX(-50%);
}
.Sign_Up_errMsg {
  color: red;
}

.Sign_Up_intro {
  margin: 0 auto;
  width: 400px;
  color: #444;
}
/* .Sign_Up_intro h2 {
  font-size: 30px;
  font-weight: bold;
  line-height: 24px;
  margin: 0 0 32px;
} */
.Sign_Up_intro p {
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
}
.Sign_Up_intro p .word_space {
  display: block;
  margin: 7px 0;
}
.Sign_Up_intro p span:nth-of-type(2) {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  letter-spacing: -0.03%;
}
.Sign_Up_intro .Sign_menu {
  margin: 31px 0 18px;
  /* height: 150px; */
  font-size: 14px;
  padding-inline-start: 0;
}
.Sign_Up_intro .Sign_menu li {
  margin-bottom: 18px;
}
.Sign_Up_intro .Sign_menu li a {
  display: block;
  width: 320px;
  height: 48px;
  border-bottom: 0 solid black;
  border: 1px solid #c9c9c9 !important;
  margin: 0 auto;
  border-radius: 24px;
  line-height: 48px;
  position: relative;
}
.Sign_Up_intro .Sign_menu li a i {
  position: absolute;
  font-size: 1.4em;
  left: 56px;
  top: 50%;
  transform: translateY(-50%);
}
.Sign_Up_intro .Sign_menu li a span {
  width: 168px;
  position: absolute;
  right: 69px;
}
.Sign_Up_intro .Sign_bottom {
  position: relative;
  padding-top: 22px;
  padding-inline-start: 0;
}
.Sign_Up_intro .Sign_bottom li {
  display: inline-block;
  position: relative;
}
.Sign_Up_intro .Sign_bottom li p {
  font-size: 16px;
  font-weight: normal;
  margin: 0 27px 0;
  line-height: 24px;
}
.Sign_Up_intro .Sign_bottom li a {
  display: block;
  background-color: #2d2d36;
  color: #fff !important;
  font-size: 14px;
  font-weight: 700px;
  width: 126px;
  height: 48px;
  line-height: 48px;
  border-radius: 24px;
}
.Sign_bottom li p img {
  position: absolute;
  left: 0;
  width: 24px;
}
.Sign_bottom::before {
  content: "";
  width: 320px;
  height: 1px;
  position: absolute;
  top: 0;
  background-color: #999999;
}

.Footer_Auto_Height {
  overflow: visible !important;
  max-height: 3000px !important;
}

.Sign_Up {
  color: black;
  /* margin-top: 50px; */ /*sohyun 수정*/
}

.Sign_Up .Sign_Up_header {
  margin-bottom: 60px;
}

.Sign_Up .Sign_Up_header h2 {
  font-size: 30px;
  font-weight: 700;
  line-height: 24px;
}
.Sign_Up .Sign_Up_header p {
  font-size: 18px;
  line-height: 24px;
}
.Sign_Up .Sign_Up_header p br {
  display: none;
}

.Sign_Up_menu ul {
  box-sizing: border-box;
  margin: 0 auto;
}

.Sign_Up_menu ul li {
  display: inline-block;
}

.Sign_Up_menu ul li a {
  display: block;
  color: #000;
  width: 200px;
  height: 200px;
  padding: 2.1vw 0 0 0;
  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.Sign_Up_menu ul li a span {
  display: block;
  font-size: 18px;
  line-height: 24px;
}

.Sign_Up_menu ul li a strong {
  font-size: 24px;
}

.Sign_Up_content {
  width: 708px;
  height: 926px;
  margin: 100px auto;
}

/* 공인중개사/임대인/일반 가입 */
.Sign_Up_Page {
  width: 100%;
  height: 100%;
  margin-left: 6px;
  clear: both;
  box-sizing: border-box;
}

.L_box,
.R_box {
  position: relative;
  width: 50%;
  height: 100%;
  float: left;
  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.2);
}

.L_box {
  padding: 0 20px;
  color: rgba(44, 44, 44, 0.5);
}

.L_box .L_box_header {
  margin-top: 30px;
  color: #000;
}

.L_box .L_box_header h2 {
  font-size: 21px;
  font-weight: 400;
  line-height: 26px;
}
.L_box .L_box_header h2 span {
  font-weight: 700;
}

.L_box .L_box_header p {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.03em;
  margin-top: -25px;
}
.L_box .Broker_Lookup label {
  text-align: left;
  width: 100%;
  font-weight: bold;
}

.L_box .Broker_Lookup label input {
  margin-bottom: 10px;
  border-radius: 18.5px;
}
.L_box .Broker_Lookup label:last-of-type input {
  margin-bottom: 17px;
}

.L_box .Broker_Lookup .R_btn {
  text-align: right;
}
.L_box .Broker_Lookup .R_btn button {
  color: #fff;
  width: 120px;
  height: 35px;
  padding: 12px 0px;
  line-height: 12px;
  background-color: #434343;
}

.L_box .upload,
.L_box .phone {
  text-align: left;
}

.L_box .upload {
  margin-bottom: 22px;
}
.L_box .phone {
  margin-bottom: 27px;
}

.L_box .upload h3,
.L_box .phone h3 {
  display: inline;
  color: rgba(44, 44, 44, 0.5);
  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
}

.L_box .upload button,
.L_box .phone button {
  width: 121px;
  height: 35px;
  background: #b9b9b9;
  border: #b9b9b9;
  color: #fff;
  padding: 12px 0px;
  line-height: 14px;
}

.L_box .Pw {
  text-align: left;
}

.L_box .Pw label {
  width: 100%;
  margin-bottom: 14px;
  font-weight: 700;
}

.L_box .Pw label input {
  box-sizing: border-box;
  border-radius: 18.5px;
}

.L_box .Pw_box {
  position: relative;
}

.L_box .Join {
  position: absolute;
  bottom: 44px;
  left: 0;
}

.L_box .Sign_Up_btn {
  width: 70%;
  padding: 17px 61.7px;
  border-radius: 24px;
  background-color: #434343;
  color: #fff;
}

/* 왼쪽 */

.R_box {
  background-color: #434343;
  color: #fff;
}

.R_box .R_box_header {
  margin-top: 30px;
}

.R_box .R_box_header h2 {
  font-size: 21px;
  line-height: 26px;
  letter-spacing: -0.03em;
  font-weight: 400;
}
.R_box .R_box_header h2 strong {
  font-weight: 700;
  letter-spacing: -0.05em;
}

.R_box .R_box_content {
  padding: 0 28px 0 74.86px;
  text-align: left;
}

.R_box .R_box_content .text_box {
  margin-top: 44px;
}

.R_box .R_box_content .text_box:first-of-type {
  margin-top: 49px;
}

.R_box .R_box_content .text_box:last-of-type p {
  margin-bottom: 25px;
}

.R_box .R_box_content .text_box i {
  font-size: 20px;
  float: left;
  margin-left: -48px;
}

.R_box .R_box_content .text_box:nth-of-type(2) img, /* 이미지 위치조정 */
.R_box .R_box_content .text_box:nth-of-type(4) img {
  margin-top: -1.5px;
}

.R_box .R_box_content .text_box h3 {
  font-size: 18.2px;
  line-height: 22px;
}

.R_box .R_box_content .text_box p {
  font-size: 15.4px;
  line-height: 24px;
  margin-top: -15px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: -0.0916667px;
}

.R_box .R_box_content .text_box .size_down {
  font-size: 14.4px;
}

@media screen and (max-width: 1024px) {
  .container_max_width {
    max-width: 890px;
  }
  .Sign_Up_menu ul li a {
    padding: 4vw 0 0 0;
  }
  .Sign_Up_content {
    width: 83vw;
  }
}

/* @media 테블릿*/
@media screen and (max-width: 768px) {
  /* Sign up intro page */
  .container_max_width {
    max-width: 850px;
  }

  /* sohyun modify*/
  /* .Sign_Up_intro {
    margin-top: 120px;
  } */

  /* Sign up page */
  .Sign_Up .Sign_Up_header h2 {
    font-size: 24px;
  }

  .Sign_Up .Sign_Up_header p {
    font-size: 16px;
  }

  /* .Sign_Up_menu ul {
    width: 87vw;
  } */

  .Sign_Up_menu ul li a {
    width: 143.91px;
    height: 127.14px;
    padding: 3vw 0 0 0;
  }
  .Sign_Up_menu ul li a span {
    font-size: 14px;
    margin-bottom: -14px;
  }

  .Sign_Up_menu ul li a strong {
    font-size: 18px;
  }
  .Sign_Up_content {
    width: 90vw;
  }

  .L_box .L_box_header {
    margin-top: 28.19px;
  }

  .L_box .L_box_header h2 {
    font-size: 20px;
    line-height: 24px;
  }

  .L_box .L_box_header p {
    font-size: 13px;
  }

  .L_box .Broker_Lookup label input {
    margin-bottom: 4px;
    border-radius: 18.5px;
    height: 35.7px;
  }

  .L_box .Broker_Lookup label:last-of-type input {
    margin-bottom: 16px;
  }

  .L_box .Broker_Lookup .R_btn button {
    color: #fff;
    width: 112.74px;
    height: 32.88px;
    padding: 9px 0px;
    font-size: 13px;
  }

  .L_box .upload {
    margin-bottom: 13.15px;
  }
  .L_box .phone {
    margin-bottom: 32.88px;
  }

  .L_box .upload h3,
  .L_box .phone h3 {
    font-size: 13px;
    line-height: 16px;
  }

  .L_box .upload button,
  .L_box .phone button {
    width: 113.68px;
    height: 32.88px;
    padding: 9px 0px 9.88px;
    font-size: 13px;
  }

  .L_box .Pw label {
    margin-bottom: 10px;
  }

  .L_box .Pw label input {
    height: 35.7px;
  }

  .L_box .Join {
    position: absolute;
    bottom: 38.52px;
    left: 0;
  }
  .L_box .Sign_Up_btn {
    padding: 15.62px 61.7px 15.48px;
  }

  .R_box .R_box_header {
    margin-top: 28.19px;
  }
  .R_box .R_box_header h2 {
    font-size: 20px;
    line-height: 24px;
  }
  .R_box .R_box_header h2 strong {
    letter-spacing: -0.03em;
  }
  .R_box .R_box_content {
    padding: 0 26.71px 0 70.57px;
  }
  .R_box .R_box_content .text_box {
    margin-top: 41.34px;
  }
  .R_box .R_box_content .text_box:first-of-type {
    margin-top: 46.04px;
  }
  .R_box .R_box_content .text_box img {
    margin-left: -46.51px;
  }
  .R_box .R_box_content .text_box h3 {
    font-size: 17.2px;
    line-height: 21px;
  }
  .R_box .R_box_content .text_box p {
    font-size: 14.4px;
    margin-top: -15.91px;
  }
}

@media screen and (max-width: 665px) {
  .container_padding_reset {
    padding: 0;
  }
  .card_padding_reset {
    padding: 0;
    padding-top: 1px;
  }
  .Sign_Up_content {
    width: 100%;
  }
  .Sign_Up_content .Sign_Up_Page {
    margin: 0;
  }
}

@media screen and (max-width: 576px) {
  .L_box,
  .R_box {
    width: 100%;
    box-shadow: none;
    box-sizing: border-box;
  }
  .Sign_Up_content {
    margin: 20px auto;
  }

  .Sign_Up_menu ul li a {
    width: 100px;
    height: 100px;
  }
  .Sign_Up_menu ul li a span {
    font-size: 10px;
  }

  .Sign_Up_menu ul li a strong {
    font-size: 14px;
  }
  .card.modal {
    position: fixed;
    height: 100%;
    top: 53px;
    left: 50%;
    transform: translateX(-50%);
  }
  .page-header .modal .container {
    height: calc(100vh - 28em);
  }
}

/* @media 모바일*/
@media screen and (max-width: 375px) {
  .Sign_Up_intro {
    width: 100%;
    margin-top: 50px;
  }
  /* .Sign_Up_intro h2 {
    font-size: 24px;
  } */
  .Sign_Up_intro p {
    font-size: 14px;
    letter-spacing: -0.05em;
  }
  .Sign_Up_intro p span:nth-of-type(2) {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }

  .Sign_Up_intro .Sign_menu {
    margin: 15px 0 18px;
  }

  .Sign_Up_intro .Sign_menu li {
    margin-bottom: 15px;
  }
  .Sign_Up_intro .Sign_menu li a {
    width: 259px;
    height: 41px;
    line-height: 41px;
    letter-spacing: -0.05em;
  }
  .Sign_Up_intro .Sign_menu li a img {
    line-height: 26px;
    left: 53px;
    top: 8px;
  }

  .Sign_Up_intro .Sign_menu li a span {
    width: 135.98px;
    right: 48.89px;
  }
  .Sign_Up_intro .Sign_bottom li p {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.05em;
  }

  .Sign_Up_intro .Sign_bottom li a {
    font-size: 12px;
    font-weight: 700px;
    width: 105px;
    height: 32px;
    line-height: 32px;
  }

  .Sign_bottom::before {
    width: 258px;
  }

  /* --------------------------------------- */

  .Sign_Up .Sign_Up_header {
    margin-bottom: 20px;
  }

  .Sign_Up .Sign_Up_header p br {
    display: block;
  }
  .Sign_Up_menu ul {
    margin-left: 1.8vw;
  }
}

@media screen and (max-width: 365px) {
  .Sign_Up_menu ul {
    margin-left: 1vw;
  }
}
@media screen and (max-width: 320px) {
  .Sign_Up_menu ul li a {
    width: 95px;
    height: 95px;
  }

  .Sign_Up_menu ul {
    margin-left: -0.4vw;
  }
}
</style>
